"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingSection = void 0;
var OnboardingSection;
(function (OnboardingSection) {
    OnboardingSection["License"] = "License";
    OnboardingSection["Certification"] = "Certification";
    OnboardingSection["Experience"] = "Experience";
    OnboardingSection["Education"] = "Education";
    OnboardingSection["Reference"] = "Reference";
})(OnboardingSection = exports.OnboardingSection || (exports.OnboardingSection = {}));
//# sourceMappingURL=types.js.map